import { Box, Divider, HStack, VStack } from '@chakra-ui/react';

import { formatAmount } from 'common/formatAmount';
import SunshineIcon from 'components/_core/SunshineIcon';
import Text from 'components/_core/Text';
import Tooltip from 'components/_core/Tooltip';

import { DetailedTransactionFragment } from '../graphql/fragment/detailedTransaction.gql';
import ShineCommissions from '../ShineCommissions';
import locales from './locales';

const SwiftTransferFeesTable: React.FC<{
  transaction: DetailedTransactionFragment;
}> = ({ transaction }) => {
  const { fee, swiftTransferPayin } = transaction;

  if (!swiftTransferPayin) {
    return null;
  }

  const { initialAmount, initialCurrency } = swiftTransferPayin.ordered;

  return (
    <>
      <Divider size="lg" />
      <Box paddingX="space-24" paddingY="space-40">
        <VStack align="stretch" divider={<Divider />} spacing="space-16">
          <HStack
            alignItems="top"
            justifyContent="space-between"
            spacing="space-16"
          >
            <Text variant="secondary">{locales.initialAmount}</Text>
            <HStack spacing="space-4">
              <Tooltip
                description={locales.initialAmountDescription}
                marginX="space-16"
              >
                <Box paddingX="space-4">
                  <SunshineIcon color="grey.600" name="information" />
                </Box>
              </Tooltip>
              <Text variant="primary">
                {formatAmount({
                  currency: initialCurrency,
                  currencyDisplay: 'code',
                  forcePlusSign: false,
                  value: initialAmount,
                })}
              </Text>
            </HStack>
          </HStack>

          <HStack
            alignItems="top"
            justifyContent="space-between"
            spacing="space-16"
          >
            <Text fontWeight="weight-500" variant="primary">
              {locales.amount}
            </Text>
            <HStack spacing="space-4">
              <Tooltip
                description={locales.amountDescription}
                marginX="space-16"
              >
                <Box paddingX="space-4">
                  <SunshineIcon color="grey.600" name="information" />
                </Box>
              </Tooltip>
              <Text fontWeight="weight-500" variant="primary">
                {formatAmount({
                  forcePlusSign: false,
                  value: transaction.value,
                })}
              </Text>
            </HStack>
          </HStack>
          {fee ? <ShineCommissions transaction={transaction} /> : null}
        </VStack>
      </Box>
    </>
  );
};

export default SwiftTransferFeesTable;
